import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paymentPlanView: {},
  header: {
    fontFamily: "inter",
    fontWeight: "600",
    fontSize: "18px",
    marginBottom: "12px",
    padding: "5px",
    lineHeight: "28px",
    color: theme.palette.text.primary,
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "16px",
  },
  paymentPlanCardsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
    maxWidth: "100%",
    overflowX: "auto",
    paddingBottom: "1rem",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      gap: "16px",
      padding: "0 8px 1rem",
    },
  },
  card: {
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    flex: "1 0 0",
    overflow: "visible",
    background: theme.palette.background.primary,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      minWidth: "360px",
      margin: "0 4px",
    },
  },
  infoContainer: {
    display: "flex",
    width: "360px",
    padding: "32px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  title: {
    color: theme.palette.text.primary,
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
      lineHeight: "28px",
    },
  },
  text: {
    flex: "1 0 0",
    alignSelf: "stretch",
    overflow: "hidden",
    color: theme.palette.text.tertiary,
    textOverflow: "ellipsis",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      lineHeight: "18px",
      flex: "unset",
    },
  },
  informativeContainer: {
    display: "flex",
    padding: "32px 32px 40px 32px",
    alignItems: "flex-start",
    gap: "24px",
    flex: "1 0 0",
    position: "relative",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      padding: "32px",
      gap: "16px",
    },
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    flex: "1 0 0",
    [theme.breakpoints.down("xs")]: {
      gap: "16px",
      width: "100%",
    },
  },
  installmentDetail: {
    display: "flex",
    width: "296px",
    alignItems: "flex-start",
    gap: "12px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    "& > *:first-child": {
      flexShrink: 0,
      minWidth: 24,
      minHeight: 24,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  installmentText: {
    color: theme.palette.text.tertiary,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  actionBtnContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  scrollArrows: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: theme.spacing(1),
  },
  IconButton: {
    color: theme.palette.foreground.secondary,
    backgroundColor: theme.palette.alpha.alphaWhite90,
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
    },
  },
}));

export default useStyles;
